import React, { useEffect, useState } from "react";
import UserPhoto from "../assets/blankphoto.webp";
import { useSelector } from "react-redux";
import { useRef } from "react";
import {
  queryDocByField,
  setDocData,
  storage,
} from "../../utils/firebase/Firebase.utils";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { getDocDataSnap } from "../../utils/firebase/Firebase.utils";
import { IoCamera, IoAdd, IoHome } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import UserScreenWindow from "../User/Components/UserScreenWindow";

export default function UserSettings() {
  const currentUser = useSelector((state) => state.userObject);
  const inputRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [userData, setUserData] = useState({});
  const [addMode, setAddMode] = useState(false);
  const [occupantsArray, setOccupantsArray] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOccupant, setSelectedOccupant] = useState({});
  const [viewMode, setViewMode] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      await getDocDataSnap("users", currentUser.uid, (data) => {
        setUserData(data);
      });
    };
    fetchUserData();
  }, []);

  const handleUpload = async (e) => {
    if (!e.target.files[0]) return;

    const file = e.target.files[0];
    const storageRef = ref(storage, `userPhotos/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setProgress(progress);
      },
      (error) => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
          await setDocData("users", currentUser.uid, { photoUrl: downloadURL });
          setProgress(0);
        });
      }
    );
  };

  return (
    <UserScreenWindow label="User Settings">
      <div className="max-w-4xl mx-auto">
        {/* Profile Header Section */}
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="flex items-center gap-6">
            <div className="relative group">
              <div className="w-20 h-20 rounded-full overflow-hidden">
                <img
                  src={userData.photoUrl || UserPhoto}
                  alt="Profile"
                  className="w-full h-full object-cover"
                />
              </div>
              <button
                onClick={() => inputRef.current.click()}
                className="absolute bottom-0 right-0 bg-blue-900 text-white p-2 rounded-full hover:bg-blue-800 transition-colors"
              >
                <IoCamera className="w-4 h-4" />
              </button>
              <input
                type="file"
                className="hidden"
                ref={inputRef}
                onChange={handleUpload}
                accept="image/*"
              />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-blue-900">
                {currentUser.displayName}
              </h2>
              <div className="text-sm text-gray-500 mt-1">
                {currentUser.linkedIdentifiers?.map((identifier) => (
                  <div key={identifier} className="flex items-center gap-2">
                    <IoHome className="w-4 h-4" />
                    <span>{identifier}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          {progress > 0 && (
            <div className="mt-4">
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-900 transition-all duration-300"
                  style={{ width: `${progress}%` }}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </UserScreenWindow>
  );
}
